import {
  AfterViewInit,
  Component,
  forwardRef,
  Host,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Renderer2,
  SkipSelf
} from '@angular/core';
import {ControlContainer, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ISignaturePadConfig} from '../../interfaces/signature-pad-config.interface';
import {GlobalSignaturePadConfig} from '../../tokens/global-config.token';
import {SignaturePadControlComponent} from '../signature-pad-control/signature-pad-control.component';
export class SignaturePadCardComponent extends SignaturePadControlComponent implements OnChanges, OnInit, AfterViewInit {

  
  theme: string = 'raised';

  
  formControlName: string;

  control: FormControl;
/**
 * @param {?} renderer
 * @param {?} parentFormContainer
 * @param {?=} defaultConfig
 */
constructor(
    renderer: Renderer2,
       parentFormContainer: ControlContainer,
      defaultConfig?: ISignaturePadConfig
  ) {
    super(renderer, parentFormContainer, defaultConfig);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'signature-pad-card',
  template: `
    <div class="signature-pad-card" [ngClass]="theme">

      <div class="signature-pad">
        <canvas
          tabindex="0"
          class="signature-pad-canvas"
          width="400"
          height="200"
          #signatureCanvas>
        </canvas>
      </div>
      <div class="line-break"></div>
      <div class="actions">
        <button class="clear" (click)="clear()">
          {{'Clear Signature'}}
        </button>
      </div>

      <div class="feedback">

        <!-- initial message -->
        <div *ngIf="control.untouched && control.pristine">Sign above!</div>

        <!-- error messages -->
        <div *ngIf="control.dirty && control.invalid">
          <span class="form-text text-danger" *ngFor="let error of (control.errors | objToArray)">
           {{error.value.message}}
          </span>
        </div>

        <!-- valid message -->
        <div *ngIf="control.dirty && control.valid">Thank you!</div>

      </div>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SignaturePadCardComponent),
      multi: true
    }
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ControlContainer, decorators: [{ type: Optional }, { type: Host }, { type: SkipSelf }, ]},
{type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [GlobalSignaturePadConfig, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'theme': [{ type: Input },],
'formControlName': [{ type: Input },],
};
}

function SignaturePadCardComponent_tsickle_Closure_declarations() {
/** @type {?} */
SignaturePadCardComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SignaturePadCardComponent.ctorParameters;
/** @type {?} */
SignaturePadCardComponent.propDecorators;
/** @type {?} */
SignaturePadCardComponent.prototype.theme;
/** @type {?} */
SignaturePadCardComponent.prototype.formControlName;
/** @type {?} */
SignaturePadCardComponent.prototype.control;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
